<template>
  <v-img
    class="id-display grey lighten-4"
    :src="imgSrc"
    :max-height="maxHeight"
    contain
  />
</template>
<script>
export default {
  props: {
    avatar: {
      type: Object
    },

    maxHeight: {
      type: Number,
      default: 400
    }
  },

  computed: {
    imgSrc() {
      return this.avatar
        ? this.avatar.url
        : require('@/assets/images/default-profile.png')
    }
  }
}
</script>
